"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxIndeterminateExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/checkbox/examples/indeterminate.ts';
var CheckboxIndeterminateExample = /** @class */ (function () {
    function CheckboxIndeterminateExample() {
        this.options = ['First', 'Second', 'Third'];
        this.checkedOptions = ['First', 'Second'];
    }
    CheckboxIndeterminateExample.prototype.view = function () {
        var _this = this;
        var _a = this, checkedOptions = _a.checkedOptions, options = _a.options;
        var indeterminate = checkedOptions.length > 0 && checkedOptions.length < options.length;
        var checked = checkedOptions.length === options.length;
        return (0, mithril_1.default)(examples_1.Example, { direction: 'column', src: EXAMPLE_SRC }, [
            (0, mithril_1.default)('', [
                (0, mithril_1.default)(_1.Checkbox, {
                    checked: checked,
                    indeterminate: indeterminate,
                    label: 'Indeterminate checkbox',
                    onchange: function (e) { return _this.onCheckAll(e); },
                    style: 'display:block; margin-bottom: 15px'
                }),
                this.options.map(function (option) { return (0, mithril_1.default)(_1.Checkbox, {
                    label: option,
                    checked: checkedOptions.includes(option),
                    onchange: function (e) { return _this.onChange(e, option); },
                    style: 'display:block; margin-bottom: 10px'
                }); })
            ])
        ]);
    };
    CheckboxIndeterminateExample.prototype.onCheckAll = function (e) {
        this.checkedOptions = e.target.checked ? tslib_1.__spreadArray([], this.options, true) : [];
    };
    CheckboxIndeterminateExample.prototype.onChange = function (e, option) {
        if (e.target.checked) {
            this.checkedOptions.push(option);
        }
        else {
            var index = this.checkedOptions.indexOf(option);
            this.checkedOptions.splice(index, 1);
        }
    };
    return CheckboxIndeterminateExample;
}());
exports.CheckboxIndeterminateExample = CheckboxIndeterminateExample;
